export const affinityCalculatorModule = {
  name: 'Affinity Calculator',
};

export const favouriteSignModule = {
  name: 'Favourite Sign',
};

export const setFilterByInitialModule = {
  name: 'Set Filter By initial',
};
